module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_bdtong_m2.8a3d1b5b331575d4ebd74d4b6c780ae4.png";